import { ExstResponseTranslator } from './exst-response-translator';

function* translatedArrayGeneratorFun(){ //save to array within generator, to avoid destroying the object
    while(true){
      const [key, value] = yield;
      ExstResponseTranslator.translated[key] = value;
    }
}

const generator = translatedArrayGeneratorFun();

export default generator;
